<template>
  <Workspace
    v-if="currentProject"
    :key="currentProject.id"
    :project="currentProject"
    :book-id="currentProject.bookId"
    :projects="book.projects"
    :allow-edit="!currentProject.isLocked"
  />
</template>

<script>
import Workspace from '@/components/workspace/Workspace'
import localStorageService from '@/core/local-storage'

import { defineComponent, computed, onBeforeUnmount, watch, onMounted } from 'vue'
import { useStore } from 'vuex'
import { useRoute, useRouter } from 'vue-router'

export default defineComponent({
  name: 'BookView',

  components: { Workspace },

  setup () {
    const { state, dispatch, commit, getters } = useStore()
    const route = useRoute()
    const router = useRouter()

    const currentProject = computed(() => state.project.currentProject)
    const hasTemplates = computed(() => getters.hasTemplates)
    const isTrialOver = computed(() => getters.isTrialOver)
    const isTeamAccount = computed(() => getters.isTeamAccount)
    const book = computed(() => state.book.book)
    const booksMemory = computed(() => state.book.booksMemory)
    const bookId = computed(() => route.params.id)
    const projectId = computed(() => route.query.page)
    const team = computed(() => state.team.team)

    watch(projectId, (value) => {
      if (value) {
        dispatch('getProject', projectId.value).then(res => {
          document.title = res.title + ' - hello ivy'
          localStorageService.setItem('lastOpenedProject', { bookId: bookId.value, projectId: projectId.value })
        })
      }
    })

    watch(bookId, () => getBookById())

    getBookById()

    if (!hasTemplates.value) {
      dispatch('getTemplates')
    }

    onMounted(() => {
      if (isTeamAccount.value && (isTrialOver.value || team.value.link !== route.params.team)) {
        router.push({ name: 'TeamBooks', params: { team: team.value.link } })
      }
    })

    onBeforeUnmount(() => {
      if (book.value?.id && currentProject.value?.id) {
        commit('setBooksMemory', {
          bookId: book.value.id,
          projectId: currentProject.value.id
        })
      }
      commit('clearProject')
    })

    function getBookById () {
      commit('toggleBookLoading', true)

      if (!bookId.value) {
        commit('toggleBookLoading', false)
        return
      }

      dispatch('getBook', bookId.value).then(res => {
        commit('toggleBookLoading', false)

        if (isTeamAccount.value && res.id && res.chat?.id) {
          dispatch('getMessages', {
            bookId: res.id,
            chatId: res.chat.id
          })
        }

        if (route.query.page) {
          dispatch('getSize', route.query.page)
          dispatch('getShare', route.query.page)

          const project = res.projects.find(item => item.id === +route.query.page)
          if (project) {
            document.title = project.title + ' - hello ivy'
            localStorageService.setItem('lastOpenedProject', { bookId: bookId.value, projectId: route.query.page })
            commit('setCurrentProject', project)
          } else {
            router.replace({ query: { page: res.projects[0]?.id } })
            dispatch('getShare', res.projects[0]?.id)
          }
        } else {
          const query = res?.id && booksMemory.value[res?.id] ? booksMemory.value[res?.id] : res.projects[0]?.id
          dispatch('getShare', query)

          router.replace({ query: { page: query } })
        }
      })
    }

    return {
      currentProject,
      book
    }
  }
})
</script>
